module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab113-df6dec306f641a31bf25ee63618de9b3.jpg";